<section class="pt-5 pb-5">

    <div class="container">

        <div class="row d-flex align-items-center">

            <div class="col-md-6 col-lg-8 d-flex justify-content-start">
                <h5 class="text-white mb-4 mb-md-0">{{ data.FACA_TESTE_GRATIS.DESCRICAO }}</h5>
            </div>

            <div class="col-md-6 col-lg-4 d-flex justify-content-start justify-content-md-end">
                <button type="button" class="btn btn-lg btn-teste p-4"
                    [routerLink]="[ data.FACA_TESTE_GRATIS.URL ] | localize">{{ data.FACA_TESTE_GRATIS.BOTAO }}</button>
            </div>

        </div>

    </div>

</section>

<div class="footer-top">

    <div class="container">

        <div class="row d-flex justify-content-center">

            <div class="col-lg-3 col-md-6 footer-links">
                <h4>{{ data.SOBRE_TOTALDOCS.SEGMENTOS.TITULO }}</h4>
                <ul>
                    <li *ngFor="let caminho of data.SOBRE_TOTALDOCS.SEGMENTOS.CAMINHOS"
                        [hidden]="caminho.HIDDEN == 'true'">
                        <a [routerLink]="[ caminho.URL ] | localize">{{ caminho.TITULO }}</a>
                    </li>
                </ul>
            </div>

            <div class="col-lg-3 col-md-6 footer-links">
                <h4>{{ data.SOBRE_TOTALDOCS.CASES.TITULO }}</h4>
                <ul>
                    <li *ngFor="let caminho of data.SOBRE_TOTALDOCS.CASES.CAMINHOS"
                        [hidden]="caminho.HIDDEN == 'true'">
                        <a [routerLink]="[ caminho.URL ] | localize">{{ caminho.TITULO }}</a>
                    </li>
                </ul>
            </div>

            <div class="col-lg-3 col-md-6 footer-links">
                <h4>{{ data.SOBRE_TOTALDOCS.PLATAFORMA.TITULO }}</h4>
                <ul>
                    <li *ngFor="let caminho of data.SOBRE_TOTALDOCS.PLATAFORMA.CAMINHOS"
                        [hidden]="caminho.HIDDEN == 'true'">
                        <a [routerLink]="[ caminho.URL ] | localize">{{ caminho.TITULO }}</a>
                    </li>
                </ul>
            </div>

            <div class="col-lg-3 col-md-6 footer-contact">
                <h4>{{ data.SOBRE_TOTALDOCS.FALE_CONOSCO.TITULO }}</h4>

                <address *ngFor="let endereco of data.SOBRE_TOTALDOCS.FALE_CONOSCO.ENDERECOS">
                    <p class="mb-0"><strong>{{ endereco.TITULO }}</strong></p>
                    <p class="mb-0">{{ endereco.COMPLEMENTO }}</p>
                    <p [innerHtml]="endereco.LOCAL"></p>
                </address>
            </div>

        </div>
        <div class="hr-fixo"></div>
            <div class="grid-term-of-use-privacy-policy">
                <div><a [routerLink]="[ data.SOBRE_TOTALDOCS.TERMOS_DE_USO.URL ] | localize">{{ data.SOBRE_TOTALDOCS.TERMOS_DE_USO.TITULO }}</a></div>
                <div><a [routerLink]="[ data.SOBRE_TOTALDOCS.POLITICA_DE_PRIVACIDADE.URL ] | localize">{{ data.SOBRE_TOTALDOCS.POLITICA_DE_PRIVACIDADE.TITULO }}</a></div>
            </div>
        <div class="hr-fixo"></div>
        <div class="row text-center">
            <div class="col-md-12">
                <h4 class="text-white">
                    {{ data.SOBRE_TOTALDOCS.REDE_SOCIAL.TITULO }}</h4>
            </div>
        </div>

        <div class="row d-flex justify-content-center text-center mt-2">

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.SOBRE_TOTALDOCS.REDE_SOCIAL.FACEBOOK }}" target="_blank">
                    <i class="fab fa-facebook fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.SOBRE_TOTALDOCS.REDE_SOCIAL.INSTAGRAM }}" target="_blank">
                    <i class="fab fa-instagram fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.SOBRE_TOTALDOCS.REDE_SOCIAL.TWITTER }}" target="_blank">
                    <i class="fab fa-twitter fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.SOBRE_TOTALDOCS.REDE_SOCIAL.LINKEDIN }}" target="_blank">
                    <i class="fab fa-linkedin fa-2x text-white"></i>
                </a>
            </div>

            <div class="col-4 col-md-2 mb-2">
                <a href="{{ data.SOBRE_TOTALDOCS.REDE_SOCIAL.YOUTUBE }}" target="_blank">
                    <i class="fab fa-youtube fa-2x text-white"></i>
                </a>
            </div>

        </div>

    </div>

</div>

<div class="container">
    <div class="copyright">
        &copy; Copyright 2021 - <a href="http://www.sirius.co" target="_blank"><strong>Sirius
                Software</strong></a>. {{ data.RODAPE.TITULO }}
    </div>
</div>